<template>
  <div class="lead-page">
    <div :class="`container-feature ${isEmbed ? 'container-feature-embed' : ''}`">
      <LeadFeature />
    </div>
    <div class="container-form">
      <LeadForm @onSubmit="submitLead" :disabled="isLoading" />
    </div>
    <v-dialog v-model="submitDialog" max-width="500" persistent>
      <v-card color="surface-bright" rounded="lg" variant="elevated">
        <template v-slot:title>
          <v-icon v-if="statusDialog == 'success'" color="success" class="success">mdi-check-circle</v-icon>
          <v-icon v-else-if="statusDialog == 'error'" color="error" class="error">mdi-close-circle</v-icon>
          <v-icon v-else color="surface-light" class="surface-light">mdi-alert-circle</v-icon>
        </template>
        <template v-slot:subtitle>
          <div v-if="statusDialog == 'success'">{{ $t('responseBox.successTitle') }}</div>
          <div v-else-if="statusDialog == 'error'">{{ $t('responseBox.errorTitle') }}</div>
          <div v-else>-</div>
        </template>
        <template v-slot:text v-if="statusDialog == 'success'">
          <div>{{ $t('responseBox.successSubTitle') }}</div>
          <div>{{ $t('responseBox.successSubTitle2') }}</div>
        </template>
        <template v-slot:text v-else-if="statusDialog == 'error'">
          <div>{{ $t('responseBox.errorSubTitle') }}</div>
          <div>{{ $t('responseBox.errorSubTitle2') }}</div>
        </template>
        <template v-slot:text v-else>
          <div>{{ $t('responseBox.errorSubTitle2')}}</div>
        </template>
        <v-card-actions class="flex-center" style="justify-content: center;">
          <v-btn @click="statusDialog = null; submitDialog = false;" color="success" variant="elevated"
            v-if="statusDialog == 'success'">
            {{ $t('responseBox.done') }}
          </v-btn>
          <v-btn @click="statusDialog = null; submitDialog = false;" color="surface-light" variant="elevated" v-else>
            {{ $t('responseBox.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LeadForm from '../components/LeadForm.vue'
import LeadFeature from '../components/LeadFeature.vue'
import { useTheme } from 'vuetify'

export default {
  name: "Project",
  components: { LeadForm, LeadFeature },
  data() {
    return {
      theme: useTheme(),
      isLoading: false,
      submitDialog: false,
      statusDialog: null
    }
  },
  watch: {
    '$route.params.projectId': {
      handler(projectId) {
        if (projectId)
          this.checkProject(projectId)
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    ...mapGetters({
      project: "project/getProject"
    }),
    isEmbed() {
      return this.$route.query.embed == 'true' ? true : false;
    },
  },
  methods: {
    ...mapActions({
      getProject: "project/getProject"
    }),
    submitLead(data, error) {
      this.submitDialog = true
      if (!error && data) {
        this.statusDialog = 'success'
      } else {
        this.statusDialog = 'error'
      }
    },
    async checkProject(projectId) {
      try {
        this.isLoading = true
        await this.getProject({ projectId })
        if (!this.project || !(this.project.objectId) || (this.project?.setting?.isBookingLinkActive == false)) this.$router.replace(`/notFound`);
        if (this.project?.setting?.bookingTheme)
          this.theme.global.name = this.project.setting.bookingTheme || 'defaultTheme'
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
        this.$router.replace(`/notFound`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lead-page {
  position: relative;
  width: 100%;
  height: 100%;

  .container-feature {
    width: 50%;
    position: fixed;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .container-form {
    margin-left: 50%;
    height: 100%;
  }

  @media (max-width: 750px) {
    height: unset;

    .container-feature {
      width: 100%;
      position: relative;
      left: unset;
      top: unset;
      transform: translateY(0);
      margin-top: 5%;
    }

    .container-feature-embed {
      margin-top: 80px;
    }

    .container-form {
      margin-left: 0;
    }

  }
}

.v-card {
  *:deep() {
    .v-card-title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;

      .v-icon {
        font-size: 100px;
        padding: 60px;
        border-radius: 50%;
      }

      .v-icon.success {
        background: rgba(var(--v-theme-success), 0.2);
      }

      .v-icon.error {
        background: rgba(var(--v-theme-error), 0.2);
      }

      .v-icon.surface-light {
        background: rgba(var(--v-theme-surface-light), 0.2);

      }
    }

    .v-card-item {
      padding-bottom: 0;
    }

    .v-card-subtitle {
      margin-top: 30px;
      margin-bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
    }


  }



  .v-card-text {
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      text-align: center;
      font-size: 18px;
      // font-weight: bold;
    }
  }

  .flex-center {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;

    .v-btn {
      font-size: 18px;
      width: 60%;
      border-radius: 10px;
      height: 45px;
    }
  }

}

.success-box {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 50px;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  .success-box-in {
    background: #FFF;
    border: 1px solid #dedede;
    border-radius: 5px;
    padding: 30px;
    margin: 20px;
    color: #000;
    font-size: 25px;
    position: absolute;

    img {
      width: 50px;
      // margin: 15px 0 0 0; 
    }

    .title {
      font-size: 30px;
      color: #21389A;
    }

    .sub-title {
      font-size: 15px;
      color: #000;
      margin-bottom: 20px;
    }

    .text-small {
      font-size: 14px;

      span {
        font-size: 18px;
        margin: 0 5px;
      }
    }

    .success-box-head {
      position: absolute;
      right: 10px;
      top: 5px;

      i {
        color: #dedede;
        cursor: pointer;
      }

      i:hover {
        color: rgb(204, 0, 0);
      }
    }

    a {
      margin-top: 15px;
    }
  }
}

.cover-spin {
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  top: 50px;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    color: #000;
    font-size: 20px;
  }
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.cover-spin::after {
  content: '';
  display: block;
  position: absolute;
  left: 49%;
  top: 40%;
  width: 40px;
  height: 40px;
  border-style: solid;
  border-color: #46bd82;
  border-top-color: transparent;
  border-width: 4px;
  border-radius: 50%;
  -webkit-animation: spin .8s linear infinite;
  animation: spin .8s linear infinite;
}
</style>
